'use client'

import { useMapboxContext } from '@component/mapbox/map/context'
import { useEffect } from 'react'
import { estimateMap } from '@router'
import { useRouter } from 'next/navigation'
import { useEstimateMapContext } from '../../context'
import { mapDataLayer } from '@plugin/google/gtm/modules/estimate'

export default function MapViewControl() {

  const { map } = useMapboxContext()
  const { state, mapLoadData } = useEstimateMapContext()

  // 监听拖拽和缩放
  const router = useRouter()
  useEffect(() => {
    if (!map) return

    const dragendFn = callFun(dragendHandle, mapLoadData, router.replace, state)
    const zoomendFn = callFun(zoomHandle, mapLoadData, router.replace, state)
    map.on('dragend', dragendFn)
    map.on('zoomend', zoomendFn)

    return () => {
      map.off('dragend', dragendFn)
      map.off('zoomend', zoomendFn)
    }
  }, [map, state, router, mapLoadData])
}

function callFun(fn, ...args) {
  return fn.bind(undefined, ...args)
}
function dragendHandle(mapLoadData, replaceRouter, state, event) {
  changeUrl(state, replaceRouter, event.target)
  mapLoadData(event.target)
  console.log('dragend: load data')
}
function zoomHandle(mapLoadData, replaceRouter, state, event) {
  changeUrl(state, replaceRouter, event.target)
  mapLoadData(event.target)
  console.log('zoom: load data')
}


function changeUrl(state, replaceRouter, map) {
  const { slug } = state
  const query = { center: map.getCenter().toArray(), zoom: map.getZoom() }
  const url = estimateMap(slug, query)
  replaceRouter(url)
  setTimeout(mapDataLayer.mapChanged, 500)
}